
import { defineComponent, onMounted } from 'vue';
import { AppTable, AppCard, AppButton } from '@/components';
import { usePiggybankList } from '@/modules/piggybank/model/list';
import { PiggyBankStatus } from '@/modules/piggybank/model/mixins';
import { ROUTE_NAME_PIGGYBANK } from '@/modules/piggybank/router';
import { TableColumnType, TableConfig } from '@/components/table/types';

export default defineComponent({
    name: ROUTE_NAME_PIGGYBANK.ITEM.INDEX,
    components: { AppTable, AppCard, AppButton },
    setup() {
        const { list, total, fetchList, actions } = usePiggybankList();

        const table: TableConfig = {
            columns: [
                { type: TableColumnType.Text, label: 'ID', key: 'id' },
                { type: TableColumnType.Text, label: 'Name', key: 'name' },
                { type: TableColumnType.Text, label: 'Price', key: 'price' },
                { type: TableColumnType.Text, label: 'Value', key: 'value' },
                { type: TableColumnType.Text, label: 'From Avg Payment (c)', key: 'fromAvgPayment' },
                { type: TableColumnType.Text, label: 'To Avg Payment (c)', key: 'toAvgPayment' },
                { type: TableColumnType.Text, label: 'Current Uses', key: 'totalLinked' },
                {
                    type: TableColumnType.Image,
                    label: 'Thumbnail',
                    imageKey: 'thumbnail',
                    statusKey: 'thumbnailStatus'
                },
                { type: TableColumnType.Option, label: 'Status', key: 'status', options: PiggyBankStatus },
                { type: TableColumnType.Actions, label: 'Actions' }
            ],
            actions: [
                {
                    props: (row: any) => ({
                        icon: 'fa-edit',
                        theme: 'info',
                        tooltip: 'Edit',
                        to: { name: ROUTE_NAME_PIGGYBANK.ITEM.EDIT, params: { id: row.id } }
                    }),
                    group: 0
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-copy',
                        theme: 'info',
                        tooltip: 'Clone',
                        to: { name: ROUTE_NAME_PIGGYBANK.ITEM.CLONE, params: { id: row.id } }
                    }),
                    group: 0
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-language',
                        theme: 'info',
                        tooltip: 'Translate',
                        to: { name: ROUTE_NAME_PIGGYBANK.ITEM.TRANSLATE, params: { id: row.id } }
                    }),
                    group: 0
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-play',
                        theme: 'success',
                        tooltip: 'Enable',
                        onclick: () => actions.enable(row.id)
                    }),
                    canShow: (row: any) => row.canEnable,
                    group: 1
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-stop',
                        theme: 'warning',
                        tooltip: 'Disable',
                        onclick: () => actions.disable(row.id)
                    }),
                    canShow: (row: any) => row.canDisable,
                    group: 1
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-trash-alt',
                        theme: 'danger',
                        tooltip: 'Delete',
                        disabled: !row.canDelete,
                        onClick: () => actions.remove(row.id)
                    })
                }
            ]
        };

        onMounted(fetchList);

        return { table, list, total, fetchList, ROUTE_NAME_PIGGYBANK };
    }
});
